module.exports = __webpack_public_path__ + "static/media/rejected.35b4f533.svg";